import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import withModal from "../withModal";

import h from "../../../helpers";
import ofilter from "../../../helpers/ofilter";
import FieldListEntryText from "../../tree-field/FieldListEntryText";
import HtmlTooltip from "../../material-components/Misc/HtmlTooltip";
import makeTooltipForField from "../../tree-field/makeTooltipForField";
import { hideModal } from "../../../actions/actionCreators";
import { requestLayoutFieldTree } from "../../../actions/fieldTreeActions";
import {
    setSelectedLayoutObjects,
    requestSelectedLayoutObjects,
    requestLayoutList,
} from "../../../actions/exportLayoutActions2";

import MaterialModal from "../MaterialModal";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import TextField from "@material-ui/core/TextField";
import BouncingDots from "../../loading/BouncingDots";
import { FieldVisibilityTypes } from "../../../helpers/constants";

const theme = createTheme({
    overrides: {
        MuiInput: {
            underline: {
                "&&&&:hover:after": {
                    borderBottom: "2px solid #406eb3",
                },
                "&&&&:after": {
                    borderBottom: "2px solid #406eb3",
                },
            },
        },
        MuiInputBase: {
            input: {
                fontSize: "15px",
            },
        },
    },
});

const LayoutExportModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();
    const hide = () => {
        setRequestName("");
        setChosenLayoutId(null);
        setLayoutType("");
        setLayoutCompression("");
        setLayoutDelimiter("");
        setIncludePII(false);
        setQualifier("");
        dispatch(setSelectedLayoutObjects([], false));
        dispatch(hideModal("SHOW_LAYOUT_EXPORT"));
    };
    const [requestName, setRequestName] = useState("");
    const [chosenLayoutId, setChosenLayoutId] = useState(null);
    const [LayoutType, setLayoutType] = useState("");
    const [LayoutCompression, setLayoutCompression] = useState("");
    const [LayoutDelimiter, setLayoutDelimiter] = useState("");
    const [IncludePII, setIncludePII] = useState(false);
    const [Qualifier, setQualifier] = useState("");
    const [IncludesHeader, setIncludesHeader] = useState("");

    const layouts = useSelector(state => state.layouts);
    const layoutTypes = useSelector(state => state.vars.layoutTypes);
    const fields = useSelector(state => state.layoutfields.byId);
    const selectedLayoutObjects = useSelector(state => state.layoutObjects.selectedLayoutObjects);
    const loading = useSelector(state => state.layoutObjects.loading);

    const renderObjects = obj => {
        let element = null;
        switch (obj.ObjectType) {
            case 1: {
                //Field
                const tt = makeTooltipForField(fields[obj.ObjectId], null);

                element = (
                    <span>
                        <HtmlTooltip placement="right" title={tt} enterDelay={250} maxwidth={500}>
                            <span style={{ marginRight: "10px" }}>
                                <FieldListEntryText
                                    fieldKey={obj.ObjectId}
                                    key={"_" + obj.ObjectId}
                                    TreeType={FieldVisibilityTypes.EXPORT}
                                />
                                {"(Field)"}
                            </span>
                        </HtmlTooltip>
                    </span>
                );
                break;
            }
            case 2: {
                element = <div>{"Placeholder - " + obj.ExportName}</div>;
                break;
            }
            case 3: {
                element = <div>{"Variable - " + obj.ExportName}</div>;
                break;
            }
            case 5: {
                element = <div>{"Primary Id - " + obj.ExportName}</div>;
                break;
            }
            case 6: {
                element = element = <div>{obj.ExportName}</div>;
                break;
            }
            default:
                element = <div>{obj.ExportName + " (Campaign Only)"}</div>;
                break;
        }
        return (
            <ListItem style={{ marginRight: "35px" }} key={obj.ObjectType + "_" + obj.Id + "_" + obj.ObjectId} divider>
                {element}
            </ListItem>
        );
    };

    const exports = () => {
        if (chosenLayoutId == null) {
            h.error("Please select a layout before exporting.");
            return;
        }

        if (chosenLayoutId != null) {
            fetch("/LayoutsMain/ExportLayout", {
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify({
                    layoutId: chosenLayoutId,
                    id: modalProps.exportId,
                    requestName,
                    delimiter: LayoutDelimiter,
                    layoutType: LayoutType,
                    compressionType: LayoutCompression,
                    isAudience: modalProps.isAudience,
                    includePII: IncludePII,
                    stringObjects: JSON.stringify(selectedLayoutObjects),
                }),
            })
                .then(h.checkStatus)
                .then(h.toJson)
                .then(data => {
                    if (data.success) {
                        //notification export sent, reset state
                        hide();
                    }
                })
                .catch(error => {
                    h.error("Error sending export.", error);
                });
        } else {
            h.error("Please select a layout before exporting.");
        }
    };

    const layoutChanged = (e, obj) => {
        const selectedLayoutValue = obj.props.value;
        const selectedLayoutLabel = obj.props.name;

        if (obj == null || selectedLayoutLabel == "None") {
            setRequestName("");
            setChosenLayoutId(null);
            setLayoutType("");
            setLayoutCompression("");
            setLayoutDelimiter("");
            setIncludePII(false);
            setQualifier("");
            return;
        }
        let typeLabel = "";

        let delimiter = "";
        let qualifier = "None";
        let IncludesHeaders = "No";

        if (obj.props.item.IncludeHeaders) {
            IncludesHeaders = "Yes";
        }
        if (obj.props.item.LayoutTypeId != null) {
            typeLabel = layoutTypes.filter(x => x.value == obj.props.item.LayoutTypeId)[0].label;
        }
        if (obj.props.item.LayoutIsFixed) {
            typeLabel = "Fixed Length";
        } else {
            delimiter = obj.props.item.LayoutDelimiter;
            if (obj.props.item.Qualifier == "'") {
                qualifier = "Single Quote";
            }
            if (obj.props.item.Qualifier == '"') {
                qualifier = "Double Quote";
            }
        }
        setQualifier(qualifier);
        setChosenLayoutId(selectedLayoutValue);
        setLayoutType(typeLabel);
        setLayoutDelimiter(delimiter);
        setIncludesHeader(IncludesHeaders);
        dispatch(requestSelectedLayoutObjects(selectedLayoutValue));
    };

    const afterOpen = () => {
        dispatch(requestLayoutFieldTree());
        dispatch(requestLayoutList("replace"));
    };

    const renderLayoutSelect = () => {
        let layoutSelect = null;
        if (layouts != null) {
            const theseLayouts = ofilter(v => v["LayoutID"] != null && v["LayoutActive"] == "Y", layouts);
            const layoutList = Object.keys(theseLayouts).map(item => ({
                label: layouts[item].LayoutName,
                value: layouts[item].LayoutID,
                item: layouts[item],
            }));

            layoutSelect = (
                <FormControl style={{ minWidth: "15vw", paddingRight: "10px" }}>
                    <InputLabel id="layout">Select a Layout</InputLabel>
                    <Select
                        id="layout"
                        style={{ fontSize: "14px" }}
                        value={chosenLayoutId || ""}
                        onChange={(e, obj) => layoutChanged(e, obj)}
                    >
                        {layoutList.map((item, index) => (
                            <MenuItem key={index} name={item.label} value={item.value} item={item.item}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            );
        }
        return layoutSelect;
    };

    const renderObjectElements = () => {
        let objectElements = null;
        if (layouts != null) {
            if (selectedLayoutObjects != null) {
                objectElements = loading ? (
                    <div style={{ margin: "100px 65px" }}>
                        <BouncingDots />
                    </div>
                ) : (
                    <List
                        styles={{ overflow: "auto", maxHeight: "250px", width: "100%", position: "relative" }}
                        subheader={<ListSubheader />}
                    >
                        <ListSubheader styles={{ backgroundColor: "#FFF" }}>Export Objects</ListSubheader>
                        {selectedLayoutObjects.map(renderObjects)}
                    </List>
                );
            }
        }
        return objectElements;
    };
    return (
        <MaterialModal
            id="export-file"
            isOpen={isOpen}
            title="Export File"
            primaryButtonText="Export"
            afterOpen={afterOpen}
            onClose={hide}
            onPrimaryButtonRequest={exports}
            isPrimaryButtonDisabled={!chosenLayoutId}
            maxWidth="sm"
            fullWidth
        >
            <ThemeProvider theme={theme}>
                <FormControl>
                    <FormGroup>{renderLayoutSelect()}</FormGroup>
                    {chosenLayoutId && (
                        <FormGroup row>
                            <div className="col-sm-6">
                                <div
                                    style={{
                                        height: "250px",
                                        width: "100%",
                                        overflowY: "auto",
                                        marginTop: "30px",
                                    }}
                                >
                                    {renderObjectElements()}
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className="col-sm-6" style={{ paddingLeft: "0px", marginTop: "30px" }}>
                                    <TextField
                                        disabled
                                        style={{ width: "200px", marginBottom: "15px" }}
                                        type="text"
                                        label="Type"
                                        value={LayoutType ? LayoutType : "None"}
                                    />

                                    <TextField
                                        disabled
                                        style={{ width: "200px", marginBottom: "15px" }}
                                        type="text"
                                        label="Delimiter"
                                        value={LayoutDelimiter ? LayoutDelimiter : "None"}
                                    />

                                    <TextField
                                        disabled
                                        style={{ width: "200px", marginBottom: "15px" }}
                                        type="text"
                                        label="Field Qualifier"
                                        value={Qualifier ? Qualifier : "None"}
                                    />

                                    <TextField
                                        disabled
                                        style={{ width: "200px", marginBottom: "15px" }}
                                        type="text"
                                        label="Include Headers"
                                        value={IncludesHeader ? IncludesHeader : "No"}
                                    />
                                </div>
                            </div>
                        </FormGroup>
                    )}
                </FormControl>
            </ThemeProvider>
        </MaterialModal>
    );
};

LayoutExportModal.propTypes = {
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

export default withModal(LayoutExportModal, "SHOW_LAYOUT_EXPORT");
